import React, { useState, useContext, useEffect } from "react";

// import "../PAlauncher.css";

import {
  InputCopy,
  FormGroup,
  Select,
  Tooltip,
  StatusDot,
  Checkbox,
  Subheader,
  Button,
  Head,
  Card,
  Input,
  RadioGroup,
  Switch,
  Icon,
  ButtonAction,
  ContentBlock,
  Tag,
  Notification
} from "xsolla-uikit";

import CardNew from "../PAcardNew";

import {
  PAchart1,
  PAchart2fake,
  PAchartMap,
} from "../PAcharts";
import {
  PAlogin0fake,
  PAloginSocialfake,

  PAchart1fake,
  PAchart2
} from "../PAchart2";

import { PAinfoCollapsible } from '../uikit2';


import {
  PAusers
} from "../PAusers";

import {
  PAconnectorInv,
  PAconnectorZapier,
  PAconnectorMCH,
} from "../PAconnectors";



export default function PAusersButton({
  title,
}) {
  return (
    <FormGroup indentation="xs">

      <FormGroup indentation="xlg" style={{ width: "100%" }}>
        <PAinfoCollapsible
          title="Connect apps"
          indentation="lg"
          counter={'1 / 2'}
          opened={true}
        >
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(100px, 260px))",
              gridColumnGap: "16px",
              gridRowGap: "16px"
            }}
          >

            <PAconnectorMCH connected={true}/>
            <PAconnectorZapier>
              Sync customers' data with any other service.
            </PAconnectorZapier>


          </div>
        </PAinfoCollapsible>
      </FormGroup>





      {/* <FormGroup indentation="lg"> */}
        {/* <ContentBlock> */}
          {/* <FormGroup indentation="lg"> */}
            {/* <FormGroup indentation="lg"> */}
              {/* <FormGroup indentation="sm"> */}
{/*
                {!!title && <Head
                  appearance="separated"
                  indentation="lg"
                >
                  {title}
                </Head>} */}

              {/* </FormGroup> */}
              <PAusers type="game_store"/>
            {/* </FormGroup> */}
          {/* </FormGroup> */}
        {/* </ContentBlock> */}
      {/* </FormGroup> */}


    </FormGroup>
  );
}
